'use client';

import createTheme from './createTheme';
const defaultTheme = createTheme();
export default defaultTheme;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/styles/defaultTheme.js
// module id = 309
// module chunks = 25